import DataApi from "./DataApi";

class ScoringRuleApi extends DataApi {
  constructor() {
    super("scoring-rules");
  }

  /**
   * Fetch all scoring rules for a specific object
   * @param {string} objectName - The object name
   * @param {boolean} activeOnly - Only fetch active rules
   */
  async fetchByObject(objectName, activeOnly = true) {
    return await this.get(`/object/${objectName}?activeOnly=${activeOnly}`);
  }

  /**
   * Fetch all active scoring rules
   */
  async fetchAll() {
    return await this.get("/all");
  }

  /**
   * Fetch a single scoring rule by ID
   * @param {string} id - Rule UUID
   */
  async fetchById(id) {
    return await this.get(`/${id}`);
  }

  /**
   * Create a new scoring rule
   * @param {Object} ruleData - Rule data
   */
  async createRule(ruleData) {
    console.log("Creating scoring rule:", ruleData);
    return await this.post("", ruleData);
  }

  /**
   * Update an existing scoring rule
   * @param {string} id - Rule UUID
   * @param {Object} updateData - Updated rule data
   */
  async updateRule(id, updateData) {
    console.log("Updating scoring rule:", id, updateData);
    return await this.put(`/${id}`, updateData);
  }

  /**
   * Delete a scoring rule (soft delete)
   * @param {string} id - Rule UUID
   */
  async deleteRule(id) {
    return await this.delete(id);
  }

  /**
   * Toggle scoring rule active status
   * @param {string} id - Rule UUID
   * @param {boolean} isActive - Active status
   */
  async toggleStatus(id, isActive) {
    return await this.put(`/${id}/toggle`, { is_active: isActive });
  }

  /**
   * Evaluate a record against scoring rules
   * @param {string} objectName - Object name
   * @param {Object} recordData - Record data
   */
  async evaluate(objectName, recordData) {
    return await this.post("/evaluate", { object_name: objectName, recordData });
  }

  /**
   * Get scoring rules count for an object
   * @param {string} objectName - Object name
   */
  async getCount(objectName) {
    return await this.get(`/count/${objectName}`);
  }

  /**
   * Bulk delete scoring rules
   * @param {Array} ids - Array of rule UUIDs
   */
  async bulkDelete(ids) {
    return await this.post("/bulk-delete", { ids });
  }

  /**
   * Get score history for a record
   * @param {string} objectName - Object name
   * @param {string} recordId - Record ID
   * @param {number} days - Number of days to look back (default: 90)
   */
  async getHistory(objectName, recordId, days = 90) {
    return await this.get(`/history/${objectName}/${recordId}?days=${days}`);
  }
}

export default ScoringRuleApi;
